import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DpsVcModule } from '../../dataprotection/dataprotection-vc/dataprotection-vc.module';
import { RouterModule } from '@angular/router';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';

import ComputeVC from './compute-vc.component';

import { ComputeDashboardVc } from './dashboard-vc/compute-dashboard-vc.component';
import { ComputeServiceVc } from './dashboard-vc/compute-vc.service';

@NgModule({
    declarations: [
        ComputeVC,
        ComputeDashboardVc
    ],
    imports: [
        VcaCommonModule,
        BrowserModule,
        FormsModule,
        TranslateModule,
        ClarityModule.forRoot(),
        DpsVcModule,
        RouterModule
    ],
    providers: [
        ComputeServiceVc
    ],
    exports: [
        ComputeVC,
        ComputeDashboardVc
    ]

})
export class ComputeVCModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vc/compute-vc.module.ts